import { KT_AI_CALL_MANAGER_PAGE_TYPE } from '../ktAiCallManager.constants';

export const SELECT_PRIVACY_TYPE = {
  DEFAULT: 'PRIVACY_FOR_KAKAO_CHATBOT',
  KAKAO: 'PRIVACY_FOR_KAKAO_CHATBOT',
  [KT_AI_CALL_MANAGER_PAGE_TYPE.CASH_NOTE]: 'PRIVACY_FOR_KT_AI',
  [KT_AI_CALL_MANAGER_PAGE_TYPE.KB]: 'PRIVACY_FOR_KT_AI',
  [KT_AI_CALL_MANAGER_PAGE_TYPE.TM]: 'PRIVACY_FOR_KT_AI',
};
